import { useQuery } from '@tanstack/react-query';
import { PromotionApi } from 'api/ApiHelper';
import { promotionsQueryKey } from 'queries/promotions/queryKey';

export const useGetPromotionParticipatesByUserQuery = (promotionId: number, enabled = true) =>
  useQuery({
    queryKey: promotionsQueryKey.participatesByUser(promotionId),
    queryFn: () => PromotionApi.getParticipateByUser(promotionId),
    gcTime: 0,
    enabled,
  });
